import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, takeLatest } from "redux-saga/effects";
import * as actions from "../actions";
import * as constants from "../constants";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchCategories({ data }) {
  try {
    const response = yield axios.get(
      `${baseURL}/api/v2/admin/badges/categories`
    );
    const { success } = response.data;
    if (success) {
      yield put(actions.fetchCategoriesSuccess(response.data.data.categories));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchCategoriesError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleCreateCategories({ data }) {
  const { name } = data;
  try {
    const fd = new FormData();
    fd.append("name", name);

    const response = yield axios.post(
      `${baseURL}/api/v2/admin/badges/categories`,
      fd
    );

    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);

      yield put(actions.createCategoriesSuccess(response.data.data.category));
    } else {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.createCategoriesError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.createCategoriesError());
  }
}

export function* handleUpdateCategories({ payload }) {
  try {
    const { id, name } = payload;
    if (!id || !name) {
      return;
    }

    const fd = new FormData();
    fd.append("name", name);

    const response = yield axios.put(
      `${baseURL}/api/v2/admin/badges/categories/${id}`,
      fd
    );

    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateCategoriesSuccess(response.data.data.category));
    } else {
      console.error("API Error:", message);
      AntdAlert.error(message);
      yield put(actions.updateCategoriesError());
    }
  } catch (error) {
    yield put(actions.updateCategoriesError());
    AntdAlert.error(error?.response?.data?.message || "Something went wrong!");
  }
}

export function* watcherBadgesSaga() {
  yield takeLatest(constants.FETCH_CATEGORIES, handleFetchCategories);
  yield takeLatest(constants.CREATE_CATEGORIES, handleCreateCategories);
  yield takeLatest(constants.UPDATE_CATEGORIES, handleUpdateCategories);
}
